(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __esm = (fn, res, err) => function __init() {
    if (err) throw err[0];
    try {
      return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
    } catch (e) {
      throw err = [e], e;
    }
  };
  var __commonJS = (cb, mod) => function __require() {
    try {
      return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    } catch (e) {
      throw mod = 0, e;
    }
  };

  // node_modules/swiper/shared/utils.mjs
  var init_utils = __esm({
    "node_modules/swiper/shared/utils.mjs"() {
    }
  });

  // node_modules/swiper/modules/virtual.mjs
  var init_virtual = __esm({
    "node_modules/swiper/modules/virtual.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/keyboard.mjs
  var init_keyboard = __esm({
    "node_modules/swiper/modules/keyboard.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/mousewheel.mjs
  var init_mousewheel = __esm({
    "node_modules/swiper/modules/mousewheel.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/shared/create-element-if-not-defined.mjs
  var init_create_element_if_not_defined = __esm({
    "node_modules/swiper/shared/create-element-if-not-defined.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/navigation.mjs
  var init_navigation = __esm({
    "node_modules/swiper/modules/navigation.mjs"() {
      init_create_element_if_not_defined();
      init_utils();
    }
  });

  // node_modules/swiper/shared/classes-to-selector.mjs
  var init_classes_to_selector = __esm({
    "node_modules/swiper/shared/classes-to-selector.mjs"() {
    }
  });

  // node_modules/swiper/modules/pagination.mjs
  var init_pagination = __esm({
    "node_modules/swiper/modules/pagination.mjs"() {
      init_classes_to_selector();
      init_create_element_if_not_defined();
      init_utils();
    }
  });

  // node_modules/swiper/modules/scrollbar.mjs
  var init_scrollbar = __esm({
    "node_modules/swiper/modules/scrollbar.mjs"() {
      init_classes_to_selector();
      init_utils();
      init_create_element_if_not_defined();
    }
  });

  // node_modules/swiper/modules/parallax.mjs
  var init_parallax = __esm({
    "node_modules/swiper/modules/parallax.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/zoom.mjs
  var init_zoom = __esm({
    "node_modules/swiper/modules/zoom.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/controller.mjs
  var init_controller = __esm({
    "node_modules/swiper/modules/controller.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/a11y.mjs
  var init_a11y = __esm({
    "node_modules/swiper/modules/a11y.mjs"() {
      init_classes_to_selector();
      init_utils();
    }
  });

  // node_modules/swiper/modules/history.mjs
  var init_history = __esm({
    "node_modules/swiper/modules/history.mjs"() {
    }
  });

  // node_modules/swiper/modules/hash-navigation.mjs
  var init_hash_navigation = __esm({
    "node_modules/swiper/modules/hash-navigation.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/autoplay.mjs
  var init_autoplay = __esm({
    "node_modules/swiper/modules/autoplay.mjs"() {
    }
  });

  // node_modules/swiper/modules/thumbs.mjs
  var init_thumbs = __esm({
    "node_modules/swiper/modules/thumbs.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/free-mode.mjs
  var init_free_mode = __esm({
    "node_modules/swiper/modules/free-mode.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/grid.mjs
  var init_grid = __esm({
    "node_modules/swiper/modules/grid.mjs"() {
    }
  });

  // node_modules/swiper/modules/manipulation.mjs
  var init_manipulation = __esm({
    "node_modules/swiper/modules/manipulation.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/shared/effect-init.mjs
  var init_effect_init = __esm({
    "node_modules/swiper/shared/effect-init.mjs"() {
    }
  });

  // node_modules/swiper/shared/effect-target.mjs
  var init_effect_target = __esm({
    "node_modules/swiper/shared/effect-target.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/shared/effect-virtual-transition-end.mjs
  var init_effect_virtual_transition_end = __esm({
    "node_modules/swiper/shared/effect-virtual-transition-end.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/effect-fade.mjs
  var init_effect_fade = __esm({
    "node_modules/swiper/modules/effect-fade.mjs"() {
      init_effect_init();
      init_effect_target();
      init_effect_virtual_transition_end();
      init_utils();
    }
  });

  // node_modules/swiper/modules/effect-cube.mjs
  var init_effect_cube = __esm({
    "node_modules/swiper/modules/effect-cube.mjs"() {
      init_effect_init();
      init_utils();
    }
  });

  // node_modules/swiper/shared/create-shadow.mjs
  var init_create_shadow = __esm({
    "node_modules/swiper/shared/create-shadow.mjs"() {
      init_utils();
    }
  });

  // node_modules/swiper/modules/effect-flip.mjs
  var init_effect_flip = __esm({
    "node_modules/swiper/modules/effect-flip.mjs"() {
      init_create_shadow();
      init_effect_init();
      init_effect_target();
      init_effect_virtual_transition_end();
      init_utils();
    }
  });

  // node_modules/swiper/modules/effect-coverflow.mjs
  var init_effect_coverflow = __esm({
    "node_modules/swiper/modules/effect-coverflow.mjs"() {
      init_create_shadow();
      init_effect_init();
      init_effect_target();
      init_utils();
    }
  });

  // node_modules/swiper/modules/effect-creative.mjs
  var init_effect_creative = __esm({
    "node_modules/swiper/modules/effect-creative.mjs"() {
      init_create_shadow();
      init_effect_init();
      init_effect_target();
      init_effect_virtual_transition_end();
      init_utils();
    }
  });

  // node_modules/swiper/modules/effect-cards.mjs
  var init_effect_cards = __esm({
    "node_modules/swiper/modules/effect-cards.mjs"() {
      init_create_shadow();
      init_effect_init();
      init_effect_target();
      init_effect_virtual_transition_end();
      init_utils();
    }
  });

  // node_modules/swiper/modules/index.mjs
  var init_modules = __esm({
    "node_modules/swiper/modules/index.mjs"() {
      init_virtual();
      init_keyboard();
      init_mousewheel();
      init_navigation();
      init_pagination();
      init_scrollbar();
      init_parallax();
      init_zoom();
      init_controller();
      init_a11y();
      init_history();
      init_hash_navigation();
      init_autoplay();
      init_thumbs();
      init_free_mode();
      init_grid();
      init_manipulation();
      init_effect_fade();
      init_effect_cube();
      init_effect_flip();
      init_effect_coverflow();
      init_effect_creative();
      init_effect_cards();
    }
  });

  // src/js/main.js
  var require_main = __commonJS({
    "src/js/main.js"() {
      init_modules();
      var ticking = false;
      window.addEventListener("scroll", () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const scrolled = window.scrollY;
            const speed = 0.15;
            document.body.style.setProperty("--parallax-offset", `${scrolled * speed}px`);
            ticking = false;
          });
          ticking = true;
        }
      });
      document.addEventListener("DOMContentLoaded", () => {
        const images = document.querySelectorAll(".custom-header-tiles-item img");
        let loadedCount = 0;
        const imageLoaded = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            document.querySelector(".custom-header-tiles-wrapper").classList.add("images-ready");
          }
        };
        images.forEach((img) => {
          if (img.complete) {
            imageLoaded();
          } else {
            img.addEventListener("load", imageLoaded);
            img.addEventListener("error", imageLoaded);
          }
        });
      });
      function formatSquareMeters(root = document.body) {
        const pattern = /(?<![\p{L}_])m2(?![\p{L}\p{N}_])/gu;
        const skip = [
          "script",
          "style",
          "noscript",
          "template",
          "textarea",
          "input",
          "select",
          "button",
          "code",
          "pre",
          "sup",
          "svg",
          "math",
          '[contenteditable]:not([contenteditable="false"])',
          "[data-no-unit-format]"
        ].join(",");
        const walker = document.createTreeWalker(
          root,
          NodeFilter.SHOW_TEXT,
          {
            acceptNode(node) {
              if (node.parentElement?.closest(skip)) {
                return NodeFilter.FILTER_REJECT;
              }
              pattern.lastIndex = 0;
              return pattern.test(node.data) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
            }
          }
        );
        const nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        for (const node of nodes) {
          const fragment = document.createDocumentFragment();
          let lastIndex = 0;
          pattern.lastIndex = 0;
          for (const match of node.data.matchAll(pattern)) {
            fragment.append(
              node.data.slice(lastIndex, match.index),
              "m"
            );
            const sup = document.createElement("sup");
            sup.textContent = "2";
            fragment.append(sup);
            lastIndex = match.index + match[0].length;
          }
          fragment.append(node.data.slice(lastIndex));
          node.replaceWith(fragment);
        }
      }
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
          formatSquareMeters();
        });
      } else {
        formatSquareMeters();
      }
      (function() {
        "use strict";
        var BRAND = "POLYPROFIL";
        var RE = /(?<![\w@.\/\\-])polyprofil(®)?(?![\w@]|\.(?:de|com|pl|eu|net|org|info|shop|at|ch)\b)/gi;
        var SKIP_TAGS = {
          SCRIPT: 1,
          STYLE: 1,
          NOSCRIPT: 1,
          TEXTAREA: 1,
          SELECT: 1,
          OPTION: 1,
          CODE: 1,
          PRE: 1,
          TITLE: 1,
          SVG: 1,
          TEMPLATE: 1
        };
        var INLINE_TAGS = { A: 1, SPAN: 1, STRONG: 1, B: 1, EM: 1, I: 1, U: 1, SMALL: 1, MARK: 1 };
        function isSkipped(textNode) {
          for (var el = textNode.parentElement; el; el = el.parentElement) {
            if (SKIP_TAGS[el.tagName.toUpperCase()]) return true;
            if (el.isContentEditable) return true;
            if (el.classList && el.classList.contains("no-polyprofil")) return true;
            if (el.tagName === "A" && /^(mailto|tel):/i.test(el.getAttribute("href") || "")) return true;
          }
          return false;
        }
        function hasSupAfter(node) {
          var n = node;
          while (n && n !== document.body) {
            var s = n.nextSibling;
            if (s) {
              return s.nodeType === 1 && s.tagName === "SUP" && s.textContent.trim().charAt(0) === "\xAE";
            }
            n = n.parentNode;
            if (!n || n.nodeType !== 1 || !INLINE_TAGS[n.tagName]) return false;
          }
          return false;
        }
        function makeSup() {
          var sup = document.createElement("sup");
          sup.className = "polyprofil-reg";
          sup.textContent = "\xAE";
          return sup;
        }
        function processTextNode(node) {
          var text = node.nodeValue;
          if (!text || !/polyprofil/i.test(text)) return;
          if (isSkipped(node)) return;
          var frag = document.createDocumentFragment();
          var last = 0, changed = false, m;
          RE.lastIndex = 0;
          while ((m = RE.exec(text)) !== null) {
            var end = m.index + m[0].length;
            if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
            var supAlreadyThere = end === text.length && hasSupAfter(node) && !m[1];
            frag.appendChild(document.createTextNode(BRAND));
            if (!supAlreadyThere) {
              frag.appendChild(makeSup());
              changed = true;
            } else if (m[0] !== BRAND) {
              changed = true;
            }
            last = end;
          }
          if (!changed) return;
          if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
          node.parentNode.replaceChild(frag, node);
        }
        function processTree(root) {
          if (!root) return;
          if (root.nodeType === 3) {
            processTextNode(root);
            return;
          }
          if (root.nodeType !== 1) return;
          var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
          var nodes = [], n;
          while (n = walker.nextNode()) nodes.push(n);
          nodes.forEach(processTextNode);
        }
        function fixTitle() {
          var t = document.title;
          if (/polyprofil/i.test(t)) {
            document.title = t.replace(/polyprofil®?/gi, BRAND + "\xAE");
          }
        }
        function run() {
          processTree(document.body);
          fixTitle();
          if ("MutationObserver" in window) {
            new MutationObserver(function(mutations) {
              mutations.forEach(function(mu) {
                mu.addedNodes.forEach(function(added) {
                  processTree(added);
                });
              });
            }).observe(document.body, { childList: true, subtree: true });
          }
        }
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", run);
        } else {
          run();
        }
      })();
    }
  });
  require_main();
})();
